export default __webpack_public_path__ + "copy-document.png";